import {getClient} from "./axiosClient";

const client = getClient()

export async function getTimelineEventsForCompanyId(companyId, startDate, endDate)
{
    return await client.get(`v1/timeline/events/company/${companyId}`, { params: {
        startDate: startDate,
        endDate: endDate
    }});
}

export async function getTimelineEventsForMsisdns(msisdns, startDate, endDate, includeGeofenceEvents, language = "en")
{
    return await client.get(`v1/timeline/events`, {
        params: {
            msisdns: msisdns,
            startDate: startDate,
            endDate: endDate,
            includeGeofenceEvents: includeGeofenceEvents,
            language: language
        }
    });
}

export async function getAllocationsForTransactions(transactionIds, msisdn)
{
    return await client.get(`v1/timeline/msisdn/${msisdn}/hours/transactions`, {
        params: {
            transactionId: transactionIds,
            msisdn: msisdn
        }
    });
}

export async function getAllocationsForGeofences(geofenceIds, msisdn, startDate, endDate)
{
    return await client.get(`v1/timeline/msisdn/${msisdn}/hours/geofences/range`, {
        params: {
            geofenceId: geofenceIds,
            msisdn: msisdn,
            dateRange: `${startDate}|${endDate}`
        }
    });
}